// extracted by mini-css-extract-plugin
export var fullWidthButton = "_of-0";